import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

// Get company settings (public - no auth needed for branding)
export const getSettings = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/settings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

// Update company settings (admin only)
export const updateSettings = async (settings) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_BASE_URL}/settings`, settings, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};

// Upload company logo (admin only)
export const uploadLogo = async (file) => {
  try {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('logo', file);
    
    const response = await axios.post(`${API_BASE_URL}/settings/logo`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading logo:', error);
    throw error;
  }
};

// Get top materials by department
export const getTopMaterialsByDepartment = async (limit = 10, siteId = null) => {
  try {
    const token = localStorage.getItem('token');
    const params = { limit };
    if (siteId) params.siteId = siteId;
    
    const response = await axios.get(`${API_BASE_URL}/dashboard/top-materials-by-department`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching top materials by department:', error);
    throw error;
  }
};

export default {
  getSettings,
  updateSettings,
  uploadLogo,
  getTopMaterialsByDepartment
};
